import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@features/auth'
import { impersonationService } from '@features/auth/services/impersonationService'
import { resolveAuthenticatedRedirect } from '@features/auth/utils/adminRedirect'

function RoleBoundary({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const { user } = useAuthStore()
  const target = resolveAuthenticatedRedirect({
    pathname: location.pathname,
    role: user?.role,
    impersonating: impersonationService.isActive(),
  })
  if (target) {
    return <Navigate to={target} replace />
  }
  return <>{children}</>
}

export default RoleBoundary
